function areArraysOfStringEqual(arr1, arr2) {
    var sortedArr1 = arr1.slice().sort();
    var sortedArr2 = arr2.slice().sort();
    return JSON.stringify(sortedArr1) === JSON.stringify(sortedArr2);
}
export default areArraysOfStringEqual;
//# sourceMappingURL=areArraysOfStringEqual.js.map